import React, { useMemo, useState } from "react";
import CardMenu from "components/card/CardMenu";
import Card from "components/card";

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { MdDelete, MdDeleteForever, MdEdit } from "react-icons/md";
import { IoMdEye } from "react-icons/io";


function AudioTable({ tableData, title, deleteSubAdmin }) {
  const [openAdminModal, setOpenAdminModal] = useState(false);
  const [singleData, setSingleData] = useState({});
  const [sorting, setSorting] = useState([]);


  // ✅ Use direct data without memo
  const data = Array.isArray(tableData) ? tableData : [];

  // ✅ Define columns directly (no useMemo)
  const columns = [
    // columnHelper.accessor("appID", {
    //   id: "appID",
    //   header: "APP ID",
    //   cell: (info) => info.getValue() || "Not Available",
    // }),
    columnHelper.accessor("logs_type", {
      id: "logs_type",
      header: "LOG TYPE",
      cell: (info) => info.getValue().toUpperCase(),
    }),
       columnHelper.accessor("status", {
      id: "status",
      header: "STATUS",
      cell: (info) => info.getValue().toUpperCase(),
    }),
      columnHelper.accessor("startedAt", {
      id: "startedAt",
      header: "CALL STARTED AT",
      cell: (info) =>info.getValue() ?  `${new Date(info.getValue()).toLocaleDateString()} ${new Date(info.getValue()).toLocaleTimeString()}` :"N/A",
    }),
       columnHelper.accessor("endAt", {
      id: "endAt",
      header: "CALL END AT",
      cell: (info) =>info.getValue() ?  `${new Date(info.getValue()).toLocaleDateString()} ${new Date(info.getValue()).toLocaleTimeString()}` :"N/A",
    }),
    columnHelper.accessor("user", {
      id: "user",
      header: "USER",
      cell: (info) => info.getValue()?.name,
    }),
    columnHelper.accessor("user", {
      id: "user",
      header: "USER EMAIL",
      cell: (info) => info.getValue()?.email,
    }),
    columnHelper.accessor("host", {
      id: "host",
      header: "HOST",
      cell: (info) => info.getValue()?.name,
    }),
       columnHelper.accessor("host", {
      id: "host",
      header: "HOST",
      cell: (info) => info.getValue()?.email,
    }),
    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: "CREATED DATE",
      cell: (info) => new Date(info.getValue()).toLocaleDateString(),
    }),
    columnHelper.accessor("updatedAt", {
      id: "updatedAt",
      header: "UPDATED DATE",
      cell: (info) => new Date(info.getValue()).toLocaleDateString(),
    }),
    // columnHelper.accessor("action", {
    //   id: "action",
    //   header: () => (
    //     <span className="text-sm font-bold text-gray-600 dark:text-white">ACTION</span>
    //   ),
    //   cell: (info) => {
    //     const rowData = info.row.original;
    //     return (
    //       <div className="flex items-center gap-2 text-sm font-bold text-navy-700 dark:text-white">
    //         <MdEdit
    //           className="cursor-pointer"
    //           onClick={() => {
    //             setSingleData(rowData);
    //             setOpenAdminModal(true);
    //           }}
    //         />
    //        {rowData?.isDeleted !==true ?   <MdDelete
    //                      className="cursor-pointer"
    //                      onClick={() => deleteSubAdmin(rowData._id)}
    //                    />
    //                    :<MdDeleteForever />}
    //         {rowData?._id ? (
    //           <a href={`/admin/admin-details/${rowData._id}`}>
    //             <IoMdEye className="cursor-pointer" />
    //           </a>
    //         ) : (
    //           <span>Not available</span>
    //         )}
    //       </div>
    //     );
    //   },
    // }),
  ];

  // ✅ Setup react-table
  const table = useReactTable({
    data,
    columns,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getRowId: row => row._id || row.appID || row.email || Math.random().toString(),
  });

  // ✅ No memo, slice directly in render
  const visibleRows = table.getRowModel().rows.slice(0, 5);

  return (
    <Card extra="w-full pb-10 p-4 h-full">
      <header className="relative flex items-center justify-between">
        <div className="text-xl font-bold text-navy-700 dark:text-white">{title}</div>
        {/* <CardMenu
          openAdminModal={openAdminModal}
          setOpenAdminModal={setOpenAdminModal}
          singleData={singleData}
          setSingleData={setSingleData}
        /> */}
      </header>

      <div className="mt-8 overflow-x-auto">
        <table className="w-full">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}
                    onClick={header.column.getToggleSortingHandler()}
                    className="cursor-pointer border-b border-gray-200 pt-4 pb-2 pr-4 text-start"
                  >
                    <div className="flex items-center justify-between text-xs text-gray-600 dark:text-white">
                      {flexRender(header.column.columnDef.header, header.getContext())}
                      {{
                        asc: " 🔼",
                        desc: " 🔽",
                      }[header.column.getIsSorted()] ?? null}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {visibleRows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    className="min-w-[150px] py-3 pr-4 text-sm text-navy-700 dark:text-white"
                  >
                    <div>{flexRender(cell.column.columnDef.cell, cell.getContext())}</div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}



export default AudioTable;
const columnHelper = createColumnHelper();
